(() => {
  if (window.PdpBundleOptionsModal) return;

  let modal;
  let modalItems;
  let modalError;
  let confirmButton;
  let skipButton;
  let confirmHandler;
  let skipHandler;
  let movedOptions = [];

  const restoreMovedOptions = () => {
    movedOptions.forEach(({ options, placeholder }) => {
      if (placeholder.parentNode) placeholder.parentNode.replaceChild(options, placeholder);
    });
    movedOptions = [];
  };

  const getModal = () => {
    modal = modal || document.querySelector('[data-pdp-bundle-options-modal]');
    if (!modal) return null;
    if (modal.parentElement !== document.body) {
      document.body.appendChild(modal);
    }
    modalItems = modal.querySelector('[data-pdp-bundle-options-items]');
    modalError = modal.querySelector('[data-pdp-bundle-options-error]');
    confirmButton = modal.querySelector('[data-pdp-bundle-options-confirm]');
    skipButton = modal.querySelector('[data-pdp-bundle-options-skip]');
    return modal;
  };

  const close = () => {
    if (!getModal()) return;
    modal.hidden = true;
    document.documentElement.classList.remove('bundle-options-modal-open');
    confirmButton.disabled = false;
    skipButton.disabled = false;
    restoreMovedOptions();
  };

  const getProperties = (product) => {
    const properties = {};
    if (!getModal()) return properties;
    const host = modal.querySelector(`[data-sc-options-host][data-variant-id="${product.dataset.variantId}"]`);
    if (!host) return properties;

    host.querySelectorAll('input[name^="properties["], select[name^="properties["], textarea[name^="properties["]').forEach((field) => {
      if ((field.type === 'checkbox' || field.type === 'radio') && !field.checked) return;
      const value = (field.value || '').trim();
      if (!value) return;
      const propertyName = field.name.replace(/^properties\[/, '').replace(/\]$/, '');
      properties[`${product.dataset.productTitle} - ${propertyName}`] = value;
    });

    return properties;
  };

  const prepareBoldProduct = (product, html) => {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const scOptions = doc.querySelector('.sc-product-options-under-cart');
    if (!scOptions) return false;

    scOptions.querySelectorAll('script:not([src])').forEach((script) => {
      try {
        new Function(script.textContent)();
      } catch (error) {
        console.warn('SC Product Options setup could not run for PDP bundle product.', error);
      }
    });

    window.BOLD = window.BOLD || {};
    window.BOLD.common = window.BOLD.common || {};
    window.BOLD.common.Shopify = window.BOLD.common.Shopify || {};
    window.BOLD.common.Shopify.products = window.BOLD.common.Shopify.products || {};
    window.BOLD.common.Shopify.variants = window.BOLD.common.Shopify.variants || {};
    window.BOLD.common.Shopify.handles = window.BOLD.common.Shopify.handles || {};

    const productId = Number(product.dataset.productId || 0);
    const variantId = Number(product.dataset.variantId || 0);
    if (productId && product.dataset.productHandle) {
      window.BOLD.common.Shopify.products[product.dataset.productHandle] = { id: productId };
      window.BOLD.common.Shopify.handles[productId] = product.dataset.productHandle;
    }
    if (productId && variantId) {
      window.BOLD.common.Shopify.variants[variantId] = {
        product_id: productId,
        product_handle: product.dataset.productHandle,
        price: Number(product.dataset.price || 0)
      };
    }

    return true;
  };

  const loadBoldOptionsScript = () => new Promise((resolve, reject) => {
    if (window.BOLD?.options?.app?.loadOptions) {
      resolve(window.BOLD.options.app);
      return;
    }

    const existingScript = document.querySelector('script[src*="options.shopapps.site/js/options.js"]');
    if (existingScript) {
      existingScript.addEventListener('load', () => resolve(window.BOLD?.options?.app), { once: true });
      existingScript.addEventListener('error', reject, { once: true });
      window.setTimeout(() => resolve(window.BOLD?.options?.app), 500);
      return;
    }

    const script = document.createElement('script');
    script.src = 'https://options.shopapps.site/js/options.js';
    script.async = true;
    script.onload = () => resolve(window.BOLD?.options?.app);
    script.onerror = reject;
    document.head.appendChild(script);
  });

  const waitForScFields = (host) => new Promise((resolve) => {
    const startedAt = Date.now();
    const check = () => {
      const field = host.querySelector('input[name^="properties["], select[name^="properties["], textarea[name^="properties["]');
      if (field || Date.now() - startedAt > 6000) {
        resolve(Boolean(field));
        return;
      }
      window.setTimeout(check, 150);
    };
    check();
  });

  const open = ({ products, onConfirm, onSkip }) => {
    if (!getModal() || !modalItems || !products.length) return false;
    restoreMovedOptions();
    confirmHandler = onConfirm;
    skipHandler = onSkip;
    modalItems.innerHTML = '';
    modalError.hidden = true;
    modalError.textContent = '';

    products.forEach((product) => {
      const item = document.createElement('div');
      item.className = 'bundle-options-modal__item';
      item.innerHTML = `
        <div class="bundle-options-modal__item-header">
          <p class="bundle-options-modal__item-title"></p>
        </div>
        <div class="bundle-options-modal__item-loading">Loading customization options...</div>
        <div class="bundle-options-modal__sc-host" data-sc-options-host data-variant-id="${product.dataset.variantId}">
          <form action="/cart/add" method="post" enctype="multipart/form-data" data-bundle-sc-product-form>
            <input type="hidden" name="id" value="${product.dataset.variantId}">
            <div class="bold_options" data-product-id="${product.dataset.productId}"></div>
          </form>
        </div>`;
      item.querySelector('.bundle-options-modal__item-title').textContent = product.dataset.productTitle || 'Product';
      modalItems.appendChild(item);
      const host = item.querySelector('[data-sc-options-host]');

      const productPath = new URL(product.dataset.productUrl, window.location.origin).pathname;
      const existingOptions = productPath === window.location.pathname
        ? Array.from(document.querySelectorAll('.bold_options')).find((options) => {
            return !modal.contains(options) && options.querySelector('.bold_option_set');
          })
        : null;

      if (existingOptions) {
        const placeholder = document.createComment('PDP bundle options return point');
        existingOptions.parentNode.insertBefore(placeholder, existingOptions);
        host.querySelector('.bold_options').replaceWith(existingOptions);
        movedOptions.push({ options: existingOptions, placeholder });
        item.querySelector('.bundle-options-modal__item-loading')?.remove();
        return;
      }

      fetch(`${product.dataset.productUrl}?_fd=0&pb=0&bundle_options_modal=1`, { credentials: 'same-origin' })
        .then((response) => {
          if (!response.ok) throw new Error('Customization options could not be loaded.');
          return response.text();
        })
        .then(async (html) => {
          if (!prepareBoldProduct(product, html)) throw new Error('No SC Product Options found for this product.');
          const app = await loadBoldOptionsScript();
          if (!app?.loadOptions) throw new Error('SC Product Options app did not load.');
          app.loadOptions('#' + modal.id + ' .bold_options');
          const hasFields = await waitForScFields(host);
          item.querySelector('.bundle-options-modal__item-loading')?.remove();
          if (!hasFields) host.insertAdjacentHTML('beforeend', '<p>No visible SC Product Options were returned for this product.</p>');
        })
        .catch((error) => {
          const loading = item.querySelector('.bundle-options-modal__item-loading');
          if (loading) loading.textContent = error.message;
        });
    });

    modal.hidden = false;
    document.documentElement.classList.add('bundle-options-modal-open');
    return true;
  };

  document.addEventListener('DOMContentLoaded', () => {
    if (!getModal()) return;
    modal.querySelectorAll('[data-pdp-bundle-options-close]').forEach((button) => button.addEventListener('click', close));
    confirmButton.addEventListener('click', () => {
      confirmButton.disabled = true;
      skipButton.disabled = true;
      const handler = confirmHandler;
      handler?.();
      close();
    });
    skipButton.addEventListener('click', () => {
      skipButton.disabled = true;
      confirmButton.disabled = true;
      const handler = skipHandler;
      close();
      handler?.();
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !modal.hidden) close();
    });
  });

  window.PdpBundleOptionsModal = { open, close, getProperties };
})();
